/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import NavAppBar from "./components/NavAppBar";

const AppRoutes = () => {

  return (
      <Router>
        <NavAppBar />
          <Routes>
            <Route path="/" element={<Home />}/>
          </Routes>
      </Router>
  )
}

export default AppRoutes
